const RETRY_DELAY_IN_MILLISECONDS = 500

const buildReloadKey = () => `arvore:chunk-reload:${window.location.pathname}`

const hasReloadKey = (key: string): boolean => {
  try {
    return window.sessionStorage.getItem(key) !== null
  } catch (error) {
    return false
  }
}

const storeReloadKey = (key: string): boolean => {
  try {
    window.sessionStorage.setItem(key, String(Date.now()))

    return true
  } catch (error) {
    return false
  }
}

const wait = (milliseconds: number) =>
  new Promise<void>(resolve => {
    setTimeout(resolve, milliseconds)
  })

export const retryImport = async <T>(loader: () => Promise<T>): Promise<T> => {
  try {
    return await loader()
  } catch (firstError) {
    await wait(RETRY_DELAY_IN_MILLISECONDS)
  }

  try {
    return await loader()
  } catch (secondError) {
    const reloadKey = buildReloadKey()

    if (hasReloadKey(reloadKey) || !storeReloadKey(reloadKey)) throw secondError

    window.location.reload()

    return new Promise<T>(() => undefined)
  }
}

export default retryImport
